import { Injectable, OnDestroy } from "@angular/core";
import { takeUntil, shareReplay } from 'rxjs/operators';
import { BehaviorSubject, Subject, Observable } from 'rxjs';

@Injectable({ providedIn: "root" })
export class TemplatingService implements OnDestroy {
  /** Name of the active theme */
  private themeName: string;
  /** Observable to subscribe to theme changes */
  private theme$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  /** Unsubscriber from all streams on destroy */
  private unsubscriber$: Subject<boolean> = new Subject();

  constructor() { }

  /** Destroy service and his streams */
  ngOnDestroy() {
    this.unsubscriber$.next(true);
    this.unsubscriber$.complete();
  }
  /** Get the actually  active theming name */
  public getActiveThemeName(): string {
    return this.themeName ? this.themeName : null;
  }
  /** Returns stored active theme as stream to get subscribed */
  public getObservable(): Observable<any> {
    return this.theme$.asObservable().pipe(
      takeUntil(this.unsubscriber$),
      shareReplay(1)
    );
  }

  /**
   * Change page active theming template
   * @param element
   * @throws Error on template not found
   */
  public setActiveTheme(themes: any, themeName: string): void {
    const theme = themes[themeName];
    if (!theme) {
      throw new Error('Template not found');
    }
    this.themeName = themeName;
    this.theme$.next(theme);
  }

  /**
   * Activate actual selected theme color variables for a given html element
   * @param element Native element to store theme color variables
   */
  public setElementTemplate(element: HTMLElement) {
    const theme = this.theme$.getValue();
    if (!theme) {
      throw new Error('No theme defined.');
    }
    for (const key in theme.colors) {
      element.style.setProperty(key, theme.colors[key]);
    }
  }

  /**
   * Set host variables for a particular component
   * @param element
   */
  public setComponentTemplate(template: any, element: HTMLElement) {
    for (const key in template) {
      element.style.setProperty(key, template[key]);
    }
  }
}
